import styled from 'styled-components';
import injectStyled from '../../utils/injectStyled';

import Buttons from './buttons';

import Visualizer from '../../Visualizer/theme.homedepotcom';
import ProductInfo from '../../ProductInfo/theme.homedepotcom';
import Price from '../../Price/theme.homedepotcom';
import Actions from '../../Actions/theme.homedepotcom';
import SecondaryActions, { Mobile as SecondaryActionsMobile } from '../../SecondaryActions/theme.homedepotcom';

const width = '367px';

const Root = styled.div`
  width: ${width};
  overflow-y: hidden;
  background-color: #fafafa;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  display: flex;
  flex-direction: column;

  .config-product-image, .config-product-info, .config-subtotal, .config-actions,
  .config-secondary-actions, .apply-now-container {
    margin: 0 20px 20px 20px;
  }


  .config-product-image {
    margin-top: 10px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .config-table-wrapper {
    margin: 0 10px 10px 10px;
    overflow-y: auto;
  }
  ${injectStyled(Buttons)}
  ${injectStyled(Visualizer('327px', '200px'))}
  ${injectStyled(ProductInfo)}
  ${injectStyled(Price)}
  ${injectStyled(Actions)}
  ${injectStyled(SecondaryActions)}
`;

export const Tablet = styled.div`
    width: 100%;
    background-color: #fafafa;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;


    .config-product-image, .config-product-info, .config-subtotal, .config-actions, .config-secondary-actions,
    .apply-now-container {
      margin: 10px;
    }

    ${injectStyled(Buttons)}
    ${injectStyled(Visualizer('calc(50vw - 30px)', 'calc(50vw - 30px)'))}
    ${injectStyled(ProductInfo)}
    ${injectStyled(Price)}
    ${injectStyled(Actions)}
    ${injectStyled(SecondaryActions)}
    ${injectStyled(SecondaryActionsMobile)}

    .summary-tablet {
      display: flex;
      flex-direction: row;
      .product-info-col, .option-table-col {
        width: 50vw;
      }
      .config-table-scroll {
        height: calc(100vh - 80px);
        overflow: auto;
      }
    }

    .config-price-container {
      margin: 1.25em 0;
    }
`;

export const Mobile = styled.div`
    width: 100%;
    background-color: #fafafa;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;


    .config-product-image, .config-product-info, .config-subtotal, .config-actions, .config-secondary-actions,
    .apply-now-container {
      margin: 10px;
    }

    ${injectStyled(Visualizer('327px', '200px'))}
    ${injectStyled(ProductInfo)}
    ${injectStyled(Price)}
    ${injectStyled(Actions)}
    ${injectStyled(SecondaryActions)}
    ${injectStyled(SecondaryActionsMobile)}
`;

export default Root;
